module.exports = __webpack_public_path__ + "img/e699330.png";